import { PlaceholderValue } from "./PlaceholderValue";

const TextValue = ({ value, className }: { value?: string; className?: string }) => {
  if (!value) {
    return <PlaceholderValue />;
  }

  return <span className={className}>{value}</span>;
};

export { TextValue };
